import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  user: any = {
    id: null,
    authorities: [],
    dateOfBirth: '',
    email: '',
    firstName: '',
    lastName: '',
    langKey: 'en',
    login: '',
    role: 0,
    practiceName: '',
    workerUserId: null,
    isSseContext: false,
    canEditCompetencies: false,
    canEditTurbineCompetencies: false,
    canEditNonTurbineCompetencies: false,
  };
  organisation: any = {
    id: null,
    name: '',
    globalDataAccess: false,
    saleForceSync: false
  };
  contractor: any = {
    id: null,
    name: '',
    maintenanceId: null,
    oem: false,
    hasPowerstationRelation: false,
  };
  powerStationOwner: any = {
    mainSiteId: null,
    skylarkUserId: null,
  };
  // one for Site owner / Power station owner / manger. Multiple for delegates
  siteOwnerUsers: { skylarkUserId: number, name: string }[] = [];
  siteOwnerToggles: any = {
    addAssets: false,
    allowRestrictionsWorkflow: false,
    allowWorkOrderScheduling: false,
    allowAssetScheduling: false,
    allowTocAcknowledgement: false,
  };
  fileFolder: any = {
    workOrderFiles : 'workOrderFiles',
    workOrderProcedureFiles : 'workOrderFiles',
    siteFormResponseFiles : 'siteFormResponse',
    siteFiles : 'siteFiles'
  };

  public readonly PHOTO_ACCEPTED_FILE_TYPES = 'image/*';
  public readonly ALL_ACCEPTED_FILE_TYPES = ' \
      .pdf,application/pdf, \
      .doc,application/msword, \
      .docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document, \
      .ppt,application/vnd.ms-powerpoint, \
      .pptx,application/vnd.openxmlformats-officedocument.presentationml.presentation, \
      .pps,application/vnd.ms-powerpoint, \
      .ppsx,application/vnd.openxmlformats-officedocument.presentationml.slideshow, \
      .odt,application/vnd.oasis.opendocument.text, \
      .xls,application/vnd.ms-excel, \
      .xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, \
      .key,application/vnd.apple.keynote, \
      image/*, \
      .txt,text/plain, \
      .csv,text/csv, \
      .rtf,application/rtf, \
      .json,application/json, \
      .xml,application/xml, \
      .md,text/markdown';
}
